const selectors = {
  body: 'body',
  header: '.header',
  moveBackBtn: '.header__action-move-back-btn',
  mainContent: '.main-content',
  offerwallContainer: '.offerwall-container',
  footer: '.footer',
  termsLink: '.js-terms',
};

export default selectors;
